import {
  Candidate,
  GamingHabit,
  PersonalInfo,
  Playtest
} from '../models/candidate';
import {
  GameExperience,
  Survey,
  SurveyAnswer as SurveyAnswer
} from '../models/survey';
import { API } from '../utils/constants';
import { Mail } from '../models/mail';
import { api } from './repositories';

export const postMail = (data: Mail, recaptchaResponse: string) =>
  api()
    .post<boolean>(`${API.endpoints.emails}/save`, data, {
      headers: { recaptchaResponse }
    })
    .then((response: any) => response.data);

export const getEnums = () =>
  api()
    .get(API.endpoints.enums)
    .then((response: any) => response.data);

export const getAllCountries = () =>
  api()
    .get(`${API.endpoints.enums}/AllCountries`)
    .then((response: any) => response.data);

export const getExists = () =>
  api()
    .get<boolean>(`${API.endpoints.candidates}/exists`)
    .then((response: any) => response.data);

export const postCandidate = (data: Candidate) =>
  api()
    .post(API.endpoints.candidates, data)
    .then((response: any) => response.data);

export const getUserStatus = () =>
  api()
    .get(`${API.endpoints.candidates}/status`)
    .then((response: any) => response.data);

export const getCandidatePersonalInfo = () =>
  api()
    .get(`${API.endpoints.candidates}/PersonalInfo`)
    .then((response: any) => response.data);

export const putCandidatePersonalInfo = (data: PersonalInfo) =>
  api()
    .put(`${API.endpoints.candidates}/PersonalInfo`, data)
    .then((response: any) => response.data);

export const getCandidatePlaytests = () =>
  api()
    .get(`${API.endpoints.candidates}/Playtests`)
    .then((response: any) => response.data);

export const putCandidatePlaytests = (data: Playtest) =>
  api()
    .put(`${API.endpoints.candidates}/Playtests`, data)
    .then((response: any) => response.data);

export const getCandidateGamingHabits = () =>
  api()
    .get(`${API.endpoints.candidates}/GamingHabits`)
    .then((response: any) => response.data);

export const putCandidateGamingHabits = (data: GamingHabit) =>
  api()
    .put(`${API.endpoints.candidates}/GamingHabits`, data)
    .then((response: any) => response.data);

export const deleteCandidate = () =>
  api()
    .delete(`${API.endpoints.candidates}`)
    .then((response: any) => response);

export const getCandidateGameExperiencesPlayed = () =>
  api()
    .get(`${API.endpoints.candidates}/Games`)
    .then((response: any) => response.data);

export const getGames = (data: string) =>
  api()
    .get(`${API.endpoints.games}/Search?query=${data}`)
    .then((response: any) => response.data);

export const postGameExperience = (data: GameExperience) =>
  api()
    .post(`${API.endpoints.candidates}/Games`, data)
    .then((response: any) => response.data);

export const putGameExperience = (data: GameExperience, id: string) =>
  api()
    .put(`${API.endpoints.candidates}/Games/${id}`, data)
    .then((response: any) => response.data);

export const deleteGameExperience = (id: string) =>
  api()
    .delete(`${API.endpoints.candidates}/Games/${id}`)
    .then((response: any) => response.data);

export const getSurvey = (id: string, isPreview?: boolean) =>
  api()
    .get<Survey>(`${API.endpoints.surveys}/${id}`, {
      params: {
        isPreview
      }
    })
    .then((response: any) => ({
      status: response.status,
      data: response.data
    }));

export const getSurveyAnswer = (id: string) =>
  api()
    .get<SurveyAnswer>(`${API.endpoints.surveys}/${id}/answers`)
    .then((response: any) => response.data);

export const postSurvey = (data: SurveyAnswer, id: string) =>
  api()
    .post(`${API.endpoints.surveys}/${id}/answers`, data)
    .then((response: any) => response.data);

export const postSessionParticipation = (id: string) =>
  api()
    .post(`${API.endpoints.sessions}/${id}/participations`)
    .then((response: any) => response.data);
